import SuccessLogotypesImg2024 from '../../assets/img/success/success_logotypes_2024.png'
import SuccessLogotypesImg2025 from '../../assets/img/success/success_logotypes_2025.png'

const SuccessLogotypes = () => {
    return (
        <>
            

        </>
    );
};

export default SuccessLogotypes;